import { gql } from '@apollo/client';

export const GET_PORTFOLIO_SUMMARY = gql`
  query GetPortfolioSummary($portfolioId: ID!) {
    portfolioSummary(portfolioId: $portfolioId) {
      holdingsValue
      holdingsValueExcludingBTC
      holdingsValueExcludingBTCAndETH
      valueChange24h
      valueChangePercentage24h
      # Altcoin stats (excluding BTC)
      valueChange24hExcludingBTC
      valueChangePercentage24hExcludingBTC
      currentPnLExcludingBTC
      currentROIExcludingBTC
      # Altcoin stats (excluding BTC and ETH)
      valueChange24hExcludingBTCAndETH
      valueChangePercentage24hExcludingBTCAndETH
      currentPnLExcludingBTCAndETH
      currentROIExcludingBTCAndETH
      current {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      planned {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      plannedConservative {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      total {
        basisCost
        proceeds
        pnl
        roi
        multiple
      }
      marketCapCategories {
        name
        value
        percentage
        currentRoi
        totalRoi
        positionCount
        exitStrategiesCount
        costs
        proceeds
      }
      groupCategories {
        name
        value
        percentage
        currentRoi
        totalRoi
        positionCount
        exitStrategiesCount
        costs
        proceeds
      }
      locationCategories {
        name
        value
        percentage
        currentRoi
        totalRoi
        positionCount
        exitStrategiesCount
        costs
        proceeds
      }
      goal {
        targetMultiple
        distLarge
        distMid
        distLow
        targetLarge
        targetMid
        targetLow
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_PORTFOLIOS = gql`
  query GetPortfolios {
    portfolios {
      id
      name
      currency
      createdAt
      updatedAt
      positionsCount
      transactionsCount
    }
  }
`; 